import "$styles/index.css"

import Alpine from "alpinejs"
import intersect from "@alpinejs/intersect"
import "./behaviors.js"
import "./shape_grid.js"

Alpine.plugin(intersect)
window.Alpine = Alpine
Alpine.start()
